export default (
  selctor,
  { visiblePercent = 0, disable = () => false } = {}
) => {
  const animate = () => {
    if (disable()) {
      return;
    }

    $(selctor)
      .filter('.doAnimation')
      .each((index, elm) => {
        const { top, height } = elm.getBoundingClientRect();
        const percent = visiblePercent / 100;
        const mustBeVisible = percent * height;
        const fromBottom = window.innerHeight - top - mustBeVisible;

        if (fromBottom > 0) {
          $(elm).removeClass('doAnimation');
          return;
        }

        return false;
      });
  };

  window.addEventListener('scroll', () => {
    animate();
  });

  return animate;
};
